import styled from 'styled-components';

export const ContainerCardWithAction = styled.div`
  background-color: #fff;
  box-shadow: 0px 4px 6px -2px rgba(16, 24, 40, 0.03),
    0px 12px 16px -4px rgba(16, 24, 40, 0.08);
  min-width: 350px;

  flex-grow: 1;
  padding: 40px 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;

  img {
    width: 150px;
    margin-bottom: 16px;
  }

  .card-with-action-infos-container {
    text-align: center;

    .card-with-action-title {
      font-size: 28px;
      line-height: 32px;
      font-weight: 700;
      margin: 0;
      margin-bottom: 8px;
      color: ${({ theme }) => theme.primaryColor ?? '#1D3054'};
    }

    .card-with-action-subtitle {
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.032px;
      color: #4d4d4d;
    }
  }

  button {
    margin-top: 16px;
    max-width: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    min-width: 100%;

    .card-with-action-infos-container {
      .card-with-action-title {
        font-size: 24px;
      }
    }
  }
`;
